import { Option } from 'shared/interface/globalInterface';
import { Nullable } from '../../utils/types';

export type Term = Option;
export type Route = Option;

export interface Props {
  terms: Term[];
  route: Route[];
  onAddNewTerm?: (term: NewTermFormData) => void;
  allowCreate?: boolean;
}

export type NewTermFormData = {
  name: string;
  amount: number;
};

export enum MODE {
  ADD = 'ADD',
  EDIT = 'EDIT',
}

export type TermViewModel = {
  key: string;
  value: string;
  label: string;
};

export type RouteViewModel = {
  key: string;
  value: Nullable<string>;
  label: string;
};
